import type { FlaggedRecord, ReviewedItem } from "@/shared/types/humanReview";

export const sampleFlaggedRecords: FlaggedRecord[] = [
  {
    id: "flag-1",
    name: "Warfarin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "active",
    flaggedDaysAgo: 3,
    reason: "This may interact with Aspirin, which is also on your medication list.",
    extracted: {
      medication: "Warfarin",
      dosage: "5mg",
      frequency: "Once daily",
      route: "Oral",
      prescribedBy: "Dr. Michael Carter",
      startDate: "2025-06-01",
    },
  },
  {
    id: "flag-2",
    name: "Amoxicillin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "active",
    flaggedDaysAgo: 2,
    reason: "Dosage appears unusually low for this medication — please confirm it's correct.",
    extracted: {
      medication: "Amoxicillin",
      dosage: "5mg",
      frequency: "Three times daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-06-10",
    },
  },
  {
    id: "flag-3",
    name: "Amoxicillin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "active",
    flaggedDaysAgo: 2,
    reason: "Duplicate entry detected from a separate uploaded document — please confirm which is current.",
    extracted: {
      medication: "Amoxicillin",
      dosage: "5mg",
      frequency: "Three times daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-06-10",
    },
  },
  {
    id: "flag-4",
    name: "Amoxicillin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "past",
    flaggedDaysAgo: 14,
    reason: "End date could not be confidently extracted from the source document.",
    extracted: {
      medication: "Amoxicillin",
      dosage: "5mg",
      frequency: "Three times daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-05-01",
    },
  },
  {
    id: "flag-5",
    name: "Metformin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "past",
    flaggedDaysAgo: 20,
    reason: "Dosage appears unusually low for this medication — please confirm it's correct.",
    extracted: {
      medication: "Metformin",
      dosage: "5mg",
      frequency: "Twice daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-03-15",
    },
  },
  {
    id: "flag-6",
    name: "Metformin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "past",
    flaggedDaysAgo: 20,
    reason: "Duplicate entry detected from a separate uploaded document — please confirm which is current.",
    extracted: {
      medication: "Metformin",
      dosage: "5mg",
      frequency: "Twice daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-03-15",
    },
  },
  {
    id: "flag-7",
    name: "Metformin",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "active",
    flaggedDaysAgo: 1,
    reason: "This may interact with your reported kidney condition — please confirm with your provider.",
    extracted: {
      medication: "Metformin",
      dosage: "5mg",
      frequency: "Twice daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-06-20",
    },
  },
  {
    id: "flag-8",
    name: "Lisinopril",
    dosage: "5mg",
    prescribedBy: "Dr. Sarah Chen",
    statusTag: "past",
    flaggedDaysAgo: 30,
    reason: "End date could not be confidently extracted from the source document.",
    extracted: {
      medication: "Lisinopril",
      dosage: "5mg",
      frequency: "Once daily",
      route: "Oral",
      prescribedBy: "Dr. Sarah Chen",
      startDate: "2025-01-10",
    },
  },
];

export const sampleRecentlyReviewed: ReviewedItem[] = [
  {
    id: "reviewed-1",
    category: "Allergy",
    name: "Peanut",
    description: "You confirmed this information.",
    decision: "accepted",
    reviewedDaysAgo: 3,
  },
  {
    id: "reviewed-2",
    category: "Condition",
    name: "Hypertension",
    description: "You rejected this information.",
    decision: "rejected",
    reviewedDaysAgo: 6,
  },
];
